import React from "react";
import {cn} from "../utils";

const ExitIcon = (
    {
        className,
        color
    }: {
        className?: string,
        color?: string
    } & React.SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="512"
        width="512"
        viewBox="0 0 24 24"
        className={cn(className)}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path clipRule="evenodd"
              d="m9 20.75c.41421 0 .75.3358.75.75s-.33579.75-.75.75h-.6-.033c-1.09215 0-1.95764 0-2.65527-.057-.71339-.0583-1.31701-.1799-1.86819-.4607-.89376-.4554-1.62042-1.1821-2.07582-2.0758-.28084-.5512-.40245-1.1548-.46073-1.8682-.057-.6977-.057-1.5631-.05699-2.6553v-.033-6.2-.03299-.00004c-.00001-1.09213-.00001-1.95762.05699-2.65524.05828-.71339.17989-1.31701.46073-1.86818.4554-.89377 1.18206-1.62043 2.07583-2.07583.55117-.28084 1.1548-.40245 1.86818-.46073.69762-.057 1.56311-.057 2.65525-.05699h.03302.1c.41421 0 .75.33579.75.75s-.33579.75-.75.75h-.1c-1.13248 0-1.93673.00058-2.56612.05201-.62063.0507-1.00488.14708-1.30935.30222-.61153.31159-1.10871.80877-1.4203 1.4203-.15514.30447-.25152.68872-.30222 1.30935-.05143.62938-.05201 1.43364-.05201 2.56612v6.2c0 1.1325.00058 1.9367.05201 2.5661.0507.6206.14708 1.0049.30222 1.3094.31159.6115.80877 1.1087 1.4203 1.4203.30447.1551.68872.2515 1.30935.3022.62938.0514 1.43364.052 2.56612.052zm6.4697-2.2196c-.2929-.2929-.2929-.7677 0-1.0606l4.7196-4.7197h-12.1893c-.41421 0-.75-.3358-.75-.75s.33579-.75.75-.75h12.1893l-4.7196-4.71967c-.2929-.2929-.2929-.76777 0-1.06066.2929-.2929.7677-.2929 1.0606 0l6 6.00003.5304.5303-.5304.5303-6 6c-.2929.2929-.7677.2929-1.0606 0z"
              fill={color || "currentColor"}
              fillRule="evenodd"/>
    </svg>
);

export {ExitIcon};